import React from 'react';
import { Navigate } from 'react-router';
import Base from './Base';
import Stuff from "./Stuff";
import GridConfig from "./GridConfig";

export default class Stuffs extends Base {
    constructor(props) {
        super(props);
        this.state = {
            caller: props.Caller,
            controllerName: 'stuff',
            data: null,
            loading: true,
            configName: 'stuffs_grid',
            moduleName: 'کالاها',
            popupComponent: null,
            topFilter: (
                <div className="pull-left" style={{ "marginTop": "-3px" }}>
                    <div className="pull-left mr-b-10 mr-l-10 small"><input className="hand" id="inv_ch1" type="checkbox" /> <span>نیاز به خرید</span></div>
                    <div className="pull-left mr-b-10 mr-l-10 small"><input className="hand" id="inv_ch2" type="checkbox" defaultChecked="checked" /> <span>کالاها</span></div>
                    <div className="pull-left mr-b-10 mr-l-10 small"><input className="hand" id="inv_ch3" type="checkbox" defaultChecked="checked" /> <span>خدمات</span></div>
                    <div className="pull-left mr-b-10 mr-l-10 small"><input className="hand" id="inv_ch4" type="checkbox" defaultChecked="checked" /> <span>کالاهای تولیدی</span></div>
                </div>)
        };
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.refreshData();
    }
    stuffCard(id) {
        this.removeKeyDown();
        this.showComponents({ component: <Stuff Caller={this} Id={id} /> });
    }
    onEdit(id) {
        this.removeKeyDown();
        this.showComponents({ component: <Stuff Caller={this} Id={id} /> });
    }
    onAdd() {
        this.removeKeyDown();
        this.showComponents({ component: <Stuff Caller={this} /> });
    }
    onGridConfig() {
        this.showComponents({ component: <GridConfig Caller={this} Config={this.getGridConfig()} /> });
    }
    getDefaultConfig() {
        return {
            name: this.state.configName,
            fields: [
                { field: "code", caption: "کد", show: true },
                { field: "farsiName", caption: "نام کالا/خدمات", show: true },
                { field: "groupName", caption: "گروه", show: true },
                { field: "taxNumber", caption: "شناسه مالیاتی", show: true },
                { field: "price", caption: "قیمت", show: true },
                { field: "inventory", caption: "موجودی", show: true },
                { field: "unitName", caption: "نام واحد", show: false },
                { field: "barcode", caption: "بارکد", show: false },
                { field: "latinName", caption: "نام لاتین", show: false },
                { field: "orderPoint", caption: "نقطه سفارش", show: false },
                { field: "orderCount", caption: "تعداد سفارش", show: false },
                { field: "note", caption: "یادداشت", show: false },
                { field: "taxRate", caption: "نرخ مالیات", show: false },
                { field: "editDateString", caption: "تاریخ ثبت", show: false },
                { field: "createDateString", caption: "تاریخ بروزرسانی", show: false }
            ]
        }
    }
    getColumns() {
        var config = this.getGridConfig();
        var t = [];
        config.fields.forEach(f => {
            if (f.field == 'code' && f.show) t.push({ field: f.field, headerName: f.caption, cellDataType: 'number', cellRenderer: (props) => { return <a className="text-primary txt-bold hand" onClick={e => this.onEdit(props.data.id)}>{props.data.code}</a> } });
            if (f.field == 'farsiName' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'groupName' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'taxNumber' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'price' && f.show) t.push({ field: f.field, headerName: f.caption, cellDataType: 'number', cellRenderer: (props) => { return this.money(props.data.price) } });
            if (f.field == 'inventory' && f.show) t.push({ field: f.field, headerName: f.caption, cellDataType: 'number', cellRenderer: (props) => { return this.money(props.data.inventory) } });
            if (f.field == 'unitName' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'barcode' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'latinName' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'orderPoint' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'orderCount' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'note' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'taxRate' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'editDateString' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'createDateString' && f.show) t.push({ field: f.field, headerName: f.caption });
        });
        return t;
    }
    renderForm() {
        return <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
            <div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e => this.closeMe()}></div>
            <div className="modal-dialog ui-draggable" style={{ "width": "85%" }}>
                <div className="modal-content">
                    <div className="modal-body">
                        <div className="mr-10">
                            <div className="center-block">
                                {this.getToolBar(false)}
                                {this.renderAgGrid({
                                    columnDefs: this.getColumns()
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                this.renderForm(),
                this.renderPopupComponent(),
            ];

        return contents;
    }
}